import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SessionTimeoutService } from './session-timeout.service';

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {

  idleState = 0;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly session: SessionTimeoutService,
    private readonly dialogRef: MatDialogRef<SessionTimeoutDialogComponent>
  ) { }

  ngOnInit(): void {
    this.session.idleState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(v => this.idleState = v);
  }

  stay(): void {
    this.session.stay();
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
